import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { UsersIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/users/customers')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <CrumbTitle icon={UsersIcon} id="userManagement.crumb.customer" />,
      title: <Translation id="userManagement.customers.page.title" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
